import { UserSessionDataForm } from "./login/user-session-data-form";

export class TestResultsDataForm {

    testResultsId: number;
	testType: number;
	score: number;
	userSessionDataForm: UserSessionDataForm;
}
